<script>
    import {projectDetail, projectSaleDetails, tokenPurchased} from "../../../../store";
    import CheckTier from "../../../../components/checkTier/CheckTier.svelte";
    import ProgressBar from "../../../../components/progressbar/ProgressBar.svelte";
    import { signer, signerAddress, provider } from "svelte-ethers-store";
    import Button from "../../../../components/button/Button.svelte"
    import { getContext, onMount } from "svelte";
    import { BigNumber, ethers } from "ethers";
    import BuyModal from "../../../../components/buy-modal/BuyModal.svelte"
    import ApprovalModal from "../../../../components/approval-modal/ApprovalModal.svelte"
    import {PROJECT_STATUSES} from "../../../../constants/constants";
    import {getTime,sliceOffDecimalNumbers} from "../../../../utils"
    import {getProjectMetaService} from "../../../../../services/api"


$: if ($projectSaleDetails.deployBlock) {
    minimumStatus = $projectSaleDetails.token.minimumTier;
    tierData = $projectSaleDetails.token.tier;
}

let saleTokenPrice, approved=false, checkApprovalPromise, eligibleStatus = 0;
let tierData, minimumStatus, latestBlock, liveStrapiProjectTimeRemaining, projectMeta,liveProjectTimeRemaining;

$: $provider && signerAddress && (async () => {
    latestBlock = await $provider.getBlockNumber()
})();

$: latestBlock && (eligibleStatus = 0)

$: if(saleCardDetails?.price) {
    saleTokenPrice = saleCardDetails.price
} else {
    saleTokenPrice = $projectDetail.project_token_price
}
export let saleCardDetails, sale, token, saleData, reserve, projectTierData;

const { open } = getContext("simple-modal");

const setApprovalValue = (approval) => {
    approved=approval;
}

const checkApproval = async () => {
    if($signerAddress && reserve && !approved) {
        const allowance = await reserve.erc20Contract.allowance($signerAddress, sale.address);
        approved = allowance.gte(BigNumber.from(ethers.constants.MaxUint256).div(BigNumber.from(2)));
    }
};
const setProjectData = async () => {
        const { data } = await getProjectMetaService($projectDetail.sale_address);
        projectMeta = data.sales[0];
    }

$: $signerAddress, reserve && checkApproval();
$: if(projectMeta && projectMeta.canEndStateConfig &&
        PROJECT_STATUSES.LIVE === $projectDetail.project_status &&
        projectMeta.startEvent) {
        setInterval(() => {
            const {timeRemaining} = getTime(projectMeta);
            liveProjectTimeRemaining = timeRemaining
        }, 1000);
        
    }
$:if($projectDetail.project_status===PROJECT_STATUSES.LIVE && !$projectDetail.sale_address){
        setInterval(() => {
            const {timeRemaining} = getTime(false,$projectDetail.project_end_time,$projectDetail.project_start_time);
            liveStrapiProjectTimeRemaining = timeRemaining
        }, 1000);
    }
$:liveStrapiTimeChecker = liveStrapiProjectTimeRemaining
$:    if($projectDetail.sale_address) {
        setProjectData();
    }


onMount(() => {
    checkApprovalPromise = checkApproval();
});



</script>
<div class="right ml-auto">
    <div class="token-counter flex">
                    <span class="flex column-direction">
                        <em>RAISE TARGET</em>
                        <b>USDC {sliceOffDecimalNumbers(saleCardDetails.raiseTarget)}</b>
                    </span>
                    
        <span class="flex column-direction ml-auto">
                        <em class="text-right">RAISE TOKEN</em>
                        <b class="text-right">{saleCardDetails.tokenName}<strong>({saleCardDetails.tokenSymbol})</strong></b>
                    </span>
    </div>
    <div class="flex list-section">
        <div class="boxes boxes-width flex column-direction">
            <div class="box gradient-bg-1">
                <span>PRICE PER RAISE TOKEN</span>
                <strong class="title-1">USDC {sliceOffDecimalNumbers( saleTokenPrice)}</strong>
            </div>
        </div>
        <div class="boxes boxes-width flex column-direction ml-auto">
            <div class="box gradient-bg-1">
                <span>TOTAL AVAILABLE RAISE TOKENS</span>
                <strong class="title-1">{sliceOffDecimalNumbers(saleCardDetails.totalSupply)}</strong>
            </div>
        </div>
    </div>
    <div class="boxes flex column-direction w-100 list-section">
        <div class="box gradient-bg">
            <span>INDIVIDUAL MAX PURCHASE AMOUNT</span>
                    <strong>{sliceOffDecimalNumbers(saleCardDetails.walletCap - $tokenPurchased)} {saleCardDetails.tokenSymbol}</strong>
        </div>
    </div>
    <div class="flex launch-date list-section">
        <div class="boxes flex column-direction">
            <div class="box">
                <span>Launch Date</span>
                <strong class="time">{saleCardDetails.startTime}</strong>
            </div>
        </div>
            <div class="boxes flex column-direction ml-auto">
            <div class="box">
                <span class="text-right">End Date</span>
                {#if $projectDetail.project_status === PROJECT_STATUSES.COMPLETED }
                <strong class="time">Raise Ended</strong>
                {:else if $projectDetail.project_status === PROJECT_STATUSES.LIVE && !$projectDetail.sale_address}
                <strong class="time">{liveStrapiTimeChecker} </strong>
                {:else if $projectDetail.project_status === PROJECT_STATUSES.LIVE && $projectDetail.sale_address}
                <strong class="time">{liveProjectTimeRemaining} </strong>
                {:else}
                <strong class="time">{saleCardDetails.endTime ? saleCardDetails.endTime : "" }</strong>

                {/if}

            </div>
        </div>
        
    </div>
    {#if $projectDetail.project_status !== PROJECT_STATUSES.UPCOMING}
    <div class="progress-title">
        <div class="flex items-center launch-date">
            <ProgressBar {saleCardDetails} {saleTokenPrice} />
        </div>
    
    </div>
    {/if}
    
    {#if $projectDetail.project_status === PROJECT_STATUSES.LIVE}
    {#if saleCardDetails.endTime === undefined}
        <p class="sale-title">Raise has not been started yet.</p>
    {:else if saleCardDetails.endTime !== "Sale Ended"}
        {#if $signer && latestBlock}
            <div class="eligible list-section">
            <CheckTier
                {signer}
                {minimumStatus}
                againstBlock={latestBlock}
                {tierData}
                readableTiers={projectTierData}
                bind:eligibleStatus={eligibleStatus}
            />
        </div>
        {/if}
        {#if checkApprovalPromise && eligibleStatus >= minimumStatus}
            {#await checkApprovalPromise}
                Checking allowance...
            {:then}
                {#if !approved && $signerAddress && reserve}
                    <Button buttonClass={"participate-btn "} on:click={() => {
                        open(ApprovalModal,{ signer, reserve, sale, saleData, setApprovalValue },{},
                        {
                    onClosed: () => {
                      checkApprovalPromise = checkApproval();
                    },
                  });
              }}>Approve</Button>
                {:else if $signerAddress && reserve}
                    <Button buttonClass={"participate-btn "} on:click={() => { open(BuyModal, { signer, sale, token, reserve, saleData }) }}>Buy</Button>
                {/if}
            {/await}
        {/if}
    {/if}
    {/if}
</div>
